export enum SelectState {
    ALL = 'all',
    PARTIAL = 'partial',
    NONE = 'none',
}
